/**
 * @param {StockOrderConf} data
 * @returns {StockOrderConf}
 */
export function initStockOrderConf(data) {
    data = {
        ...(data || {}),
        enabled: data?.enabled ?? false,
    };

    return data;
}

/**
 * @typedef {object} StockOrderConf
 *
 * @property {boolean} enabled
 */
